// extracted by mini-css-extract-plugin
export default {"scontainer":"Services_scontainer__gJ5Kf","serviceCard":"Services_serviceCard__rQnRS","icon":"Services_icon__X1Gpn"};